<template>
    <h1>Páginal Inicial</h1>
</template>

<script>
import Dashboard from "@/Layouts/Dashboard";

export default {
    props: {
        errors: {
            type: Object
        }
    },
    name: "Panel",
    layout: Dashboard
}
</script>

<style scoped>

</style>
